import { useCallback, useEffect, useRef, useState } from "react"
import { getAutomaticClaims, setAutomaticClaims } from "../../services/usersService";

export const useAutomaticClaim = () => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [automatic, setAutomatic] = useState<boolean>(false);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const loadValue = useCallback(() => {
        const _fetch = async () => {
            setLoading(true);
            try {
                const _value = await getAutomaticClaims();
                if(!isMountedRef.current)
                    return;
                setAutomatic(_value);
            }
            finally {
                if(!isMountedRef.current)
                    return;
                setLoading(false);
            }
        }
        _fetch();
    }, []);

    const setValue = useCallback((value: boolean) => {
        const _fetch = async () => {
            setLoading(true);
            try {
                await setAutomaticClaims(value);
            }
            finally {
                if(!isMountedRef.current)
                    return;
                loadValue();
            }
        }
        _fetch();
    }, []);

    useEffect(() => {
        loadValue();
    }, [loadValue]);

    return { loading, automatic, loadValue, setValue }
}